<template>
  <div class="buy-set-content pl16 pr16" v-loading="loading">
    <el-form ref="form1" :model="setForm" label-width="180px" size="small">
      <!--通信设置-->
      <div class="common-form">通信设置</div>
      <el-form-item label="最后一次读取时间：">
        {{ parseTime(timestamp_protocol) }}
      </el-form-item>

      <el-form-item label="上传间隔："
                    :rules="[{ required: true, message: '上传间隔不能为空' }]"
                    prop="SYS.SYS_HEART_PERIOD">
        <el-input type="number" v-model="setForm.SYS.SYS_HEART_PERIOD" placeholder="请输入排序"
                  class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="设备协议：" :rules="[{ required: true, message: '设备协议不能为空' }]"
                    prop="SYS.SYS_SELECTED_ITEM">
        <el-radio-group v-model="setForm.SYS.SYS_SELECTED_ITEM">
          <el-radio :label="'0'">RS232</el-radio>
          <el-radio :label="'1'">RS485</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="RS232协议：" v-if="setForm.SYS.SYS_SELECTED_ITEM === '0'"
                    :rules="[{ required: true, message: 'RS232协议不能为空' }]"
                    prop="SYS.SYS_232_PRODUCT">
        <el-select v-model="setForm.SYS.SYS_232_PRODUCT" placeholder="请选择协议" clearable size="small">
          <el-option v-for="dict in this.getDictDatas(DICT_TYPE.RS232_PROTOCOL)"
                     :key="dict.value" :label="dict.label" :value="dict.value"/>
        </el-select>
      </el-form-item>
      <el-form-item label="波特率：" v-if="setForm.SYS.SYS_SELECTED_ITEM === '0'"
                    :rules="[{ required: true, message: '波特率不能为空' }]"
                    prop="SYS.SYS_232_BAUDRATE">
        <el-select v-model="setForm.SYS.SYS_232_BAUDRATE" placeholder="请选择波特率" clearable size="small">
          <el-option v-for="dict in this.getDictDatas(DICT_TYPE.BAUD_RATE)"
                     :key="dict.value" :label="dict.label" :value="dict.value"/>
        </el-select>
      </el-form-item>

      <el-form-item label="RS485协议：" v-if="setForm.SYS.SYS_SELECTED_ITEM === '1'"
                    :rules="[{ required: true, message: 'RS485协议不能为空' }]"
                    prop="SYS.SYS_485_PRODUCT">
        <el-select v-model="setForm.SYS.SYS_485_PRODUCT" placeholder="请选择协议" clearable size="small">
          <el-option v-for="dict in this.getDictDatas(DICT_TYPE.RS485_SYS)"
                     :key="dict.value" :label="dict.label" :value="dict.value"/>
        </el-select>
      </el-form-item>
      <el-form-item label="主从机：" v-if="setForm.SYS.SYS_SELECTED_ITEM === '1'"
                    :rules="[{ required: true, message: '主从机不能为空' }]"
                    prop="SYS.SYS_485_MASTER_SLAVE">
        <el-radio-group v-model="setForm.SYS.SYS_485_MASTER_SLAVE">
          <el-radio v-for="dict in this.getDictDatas(DICT_TYPE.SYS_485_MASTER_SLAVE)"
                    :key="dict.value" :label="dict.value">{{ dict.label }}
          </el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="波特率：" v-if="setForm.SYS.SYS_SELECTED_ITEM === '1'"
                    :rules="[{ required: true, message: '波特率不能为空' }]"
                    prop="SYS.SYS_485_BAUDRATE">
        <el-select v-model="setForm.SYS.SYS_485_BAUDRATE" placeholder="请选择波特率" clearable size="small">
          <el-option v-for="dict in this.getDictDatas(DICT_TYPE.BAUD_RATE)"
                     :key="dict.value" :label="dict.label" :value="dict.value"/>
        </el-select>
      </el-form-item>

      <!--大屏设置-->
      <div class="common-form">大屏设置</div>
      <el-form-item label="大屏协议：" :rules="[{ required: true, message: '大屏协议不能为空' }]"
                    prop="SYS.SYS_BIG_SCREEN_PRODUCT">
        <el-select v-model="setForm.SYS.SYS_BIG_SCREEN_PRODUCT" placeholder="请选择波特率" clearable
                   size="small">
          <el-option v-for="dict in this.getDictDatas(DICT_TYPE.PROTOCOL_BIG_SCREEN)"
                     :key="dict.value" :label="dict.label" :value="dict.value"/>
        </el-select>
      </el-form-item>
      <el-form-item label="大屏波特率："
                    :rules="[{ required: true, message: '大屏波特率不能为空' }]"
                    prop="SYS.SYS_BIG_SCREEN_BAUDRATE">
        <el-select v-model="setForm.SYS.SYS_BIG_SCREEN_BAUDRATE" placeholder="请选择大屏波特率" clearable
                   size="small">
          <el-option v-for="dict in this.getDictDatas(DICT_TYPE.BAUD_RATE)"
                     :key="dict.value" :label="dict.label" :value="dict.value"/>
        </el-select>
      </el-form-item>
    </el-form>

    <el-form ref="form2" :model="setForm" label-width="180px" size="small">
      <!--系统参数设置-->
      <div class="common-form">系统参数设置</div>
      <el-form-item label="最后一次读取时间：">
        {{ parseTime(timestamp_sys) }}
      </el-form-item>
      <el-form-item label="重量阈值(千克)："
                    prop="SYS.SYS_FLUCTUATION_THRESHOLD">
        <el-input type="number" v-model="setForm.SYS.SYS_FLUCTUATION_THRESHOLD" placeholder="重量阈值"
                  class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="未支付尾数显示："
                    prop="SYS.SYS_UNPAID_TAIL_DISPLAY">
        <el-input type="number" v-model="setForm.SYS.SYS_UNPAID_TAIL_DISPLAY" placeholder="有效显示时间"
                  class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="上磅超时时间（S）："
                    prop="SYS.SYS_LOADING_TIMEOUT">
        <el-input type="number" v-model="setForm.SYS.SYS_LOADING_TIMEOUT" placeholder="上磅超时时间"
                  class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="重量稳定才允许支付："
                    prop="SYS.SYS_PAYMENT_STABLE">
        <el-checkbox  @change="handleCheckboxChange">是
        </el-checkbox>
      </el-form-item>
      <el-form-item label="打印结束空行："
                    prop="SYS.SYS_PRINT_END_BLANK_LINE">
        <el-input type="number" v-model="setForm.SYS.SYS_PRINT_END_BLANK_LINE" placeholder="打印结束空行"
                  class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="打印纸总长度(mm)："
                    prop="SYS.SYS_LENGTH_PAPER">
        <el-input type="number" v-model="setForm.SYS.SYS_LENGTH_PAPER" placeholder="打印纸总长度"
                  class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="系统语言："
                    prop="SYS.SYS_LANGUAGE">
        <el-select v-model="setForm.SYS.SYS_LANGUAGE" placeholder="请选择">
          <el-option label="简体中文" value="0"></el-option>
          <el-option label="英语" value="1"></el-option>
          <el-option label="俄语" value="2"></el-option>
        </el-select>
      </el-form-item>

      <div class="common-button-wrapper">
        <el-button icon="el-icon-refresh" size="small" type="info" @click="refreshFunction">立即刷新</el-button>
        <el-button icon="el-icon-files" size="small" type="primary" @click="saveFunction">立即保存</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
import PorductApi from '@/api/product.js';
import {map} from 'lodash-es';

export default {
  data() {
    return {
      formRules: {},
      timestamp_protocol: 0,
      timestamp_sys: 0,
      setForm: {
        SYS: {
          SYS_232_PRODUCT: '0',
          SYS_232_BAUDRATE: '9600',
          SYS_485_PRODUCT: '0',
          SYS_485_BAUDRATE: '9600',
          SYS_485_MASTER_SLAVE: 1,
          SYS_485_ADDRESS: '0',
          SYS_232_ADDRESS: '0',
          SYS_HEART_PERIOD: '0',
          SYS_SELECTED_ITEM: '0',
          SYS_BIG_SCREEN_PRODUCT: '0',
          SYS_BIG_SCREEN_BAUDRATE: '9600',
          SYS_FLUCTUATION_THRESHOLD: '100',
          SYS_UNPAID_TAIL_DISPLAY: '0',
          SYS_LOADING_TIMEOUT: '3600',
          SYS_PAYMENT_STABLE: '1',
          SYS_PRINT_END_BLANK_LINE: '2',
          SYS_LENGTH_PAPER: '5500',
          SYS_LANGUAGE: '0',
        },
      },
      /*是否正在加载*/
      loading: false,
    };
  },
  created() {
    let self = this;
    self.refreshFunction();
  },
  inject: ['form'],
  methods: {
    handleCheckboxChange(value) {
      this.setForm.SYS.SYS_PAYMENT_STABLE = value ? 1 : 0;
    },
    onItemChange(value) {
      this.SYS.SYS_SELECTED_ITEM = value
    },
    refreshFunction() {
      let self = this;
      self.loading = true;
      self.queue([self.readSYSFunction])
        .then(result => {
          self.loading = false;
          for (let data of result) {
            if (data.success) {
              self.$message.success(data.msg);
            } else {
              self.$message.error(data.msg);
            }
          }
        });
    },
    saveFunction() {
      let self = this;
      self.loading = true;
      self.queue([self.saveSYSFunction])
        .then(result => {
          self.loading = false;
          for (let data of result) {
            if (data.success) {
              self.$message.success(data.msg);
            } else {
              self.$message.error(data.msg);
            }
          }
        });
    },
    async queue(promiseArr) {
      var res = []
      for (let fun of promiseArr) {
        var resData = await fun()
        res.push(resData)
      }
      return res;
    },
    readSYSFunction() {
      let self = this;
      return new Promise((resolve, reject) => {
        PorductApi.invokeFunction({
          id: self.form.model.id,
          functionId: '$WB_READ',
          convert: true,
          query: {
            "type": Object.keys(this.setForm.SYS).join(',')
          },
        }, true)
          .then(res => {
            const mData = res.data.split(",");
            Object.keys(self.setForm.SYS).forEach(function (item, index) {
              self.setForm.SYS[item] = mData[index]
            })
            self.timestamp_sys = res.timestamp
            resolve({msg: '读取系统参数成功', data: res, success: true})
          })
          .catch(error => {
            resolve({msg: '读取系统参数失败', success: false});
          });
      });
    },
    saveSYSFunction() {
      let self = this;
      return new Promise((resolve, reject) => {
        self.$refs.form2.validate(valid => {
          if (valid) {
            PorductApi.invokeFunction({
              id: self.form.model.id,
              functionId: '$WB_WRITE',
              convert: true,
              query: {
                "type": Object.keys(self.setForm.SYS).join(','),
                "data": Object.values(self.setForm.SYS).join(',')
              }
            }, true)
              .then(res => {
                resolve({msg: '保存系统参数成功', data: res, success: true})
              })
              .catch(error => {
                resolve({msg: '保存系统参数失败', success: false});
              });
          } else {
            self.loading = false;
          }
        });
      });
    },
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/product/product/part/FunctionInvokeV2.vue